// see also styles/mixins/_breakpoints.scss
export const enum LAYOUT_BREAKPOINT {
  XS = 0,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1400,
}
